export const placeToRating:Record<number,number> = {
    1:30,
    2:20,
    3:10,
    4:-10,
    5:-20,
    6:-30
};